import React from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from 'src/components/ui'

import styles from './SearchUser.module.scss'
import { ListOfUsers } from './components'
import { useGetAllUsers } from './hooks/useGetAllUsers'

const SearchUser = () => {
  const [inputValue, setInputValue] = React.useState<string>('')
  const { allUsers } = useGetAllUsers()
  const { t } = useTranslation()

  const filteredUsers = inputValue
    ? allUsers.filter((user) => {
        let nameOfUser
        if (!user.username) {
          nameOfUser = user.first_name + user.last_name
        } else {
          nameOfUser = user.username
        }

        return nameOfUser?.toLowerCase().includes(inputValue.toLowerCase())
      })
    : []

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.input}>
          <input type='text' value={inputValue} onChange={(e) => setInputValue(e.target.value)} />
          {inputValue.length > 0 && (
            <button className={styles.clear} onClick={() => setInputValue('')}>
              <Icon name='delete' />
            </button>
          )}
        </div>
      </div>

      <div className={styles.users}>
        {filteredUsers.length > 0 ? (
          <>
            <p className={styles.users_title}>{t('search_user.results')}</p>
            <ListOfUsers users={filteredUsers} />
          </>
        ) : inputValue ? (
          <div className={styles.nothing}>
            <p className={styles.nothing_title}>{t('search_user.not_found')}</p>
            <p className={styles.nothing_text}>{t('search_user.invite_friend')}</p>
          </div>
        ) : null}
      </div>
    </>
  )
}

export default SearchUser
